import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const REGISTRY_API = "/studies/registries/";

export const getAllRegistries = (params) => {
  return axios.get(REGISTRY_API, {params: params}).then(res => {
    return res.data;
  });
};

export const addRegistry = (registry) => {
  return axios.post(REGISTRY_API, registry, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  });
};

export const updateRegistry = (id, body) => {
  return axios.put(`${REGISTRY_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
};

export const deleteRegistry = (id) => {
  return axios.delete(`${REGISTRY_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
};
